import { Config } from '../Config';

import { ClientConfig, SecuredApi } from './Api';

import { paths } from 'data/constants';

interface MiddlewareApi {
  fetchEventTransactionHistory: (eventId: string) => Promise<any>;
}

export class MiddlewareApiImpl extends SecuredApi implements MiddlewareApi {
  authtokenTTL = 180;
  rfidSearch = '';
  clientConfig = (): ClientConfig => {
    return {
      baseURL: Config.MIDDLEWARE,
      timeout: 15000,
    };
  };

  fetchEventTransactionHistory = async (eventId: string): Promise<any> => {
    const response = await this.client.get(paths.fetchEventTransactionHistory(eventId));
    return response.data;
  };
}

export default MiddlewareApi;
